import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const tools = [
  {
    title: 'Community Charter Template',
    description: 'A Miro template to help you create a community charter that defines your community\'s purpose, values, and ways of working.',
    url: 'https://miro.com/templates/team-charter/'
  },
  {
    title: 'Impact/Effort Matrix Template',
    description: 'A Miro template to help you prioritize initiatives for your community of practice.',
    url: 'https://miro.com/templates/impact-effort-matrix/'
  }
];

const additional = [
  {
    title: 'Building a Community of Practice',
    description: 'A comprehensive guide to establishing and growing communities of practice in organizations.',
    url: 'https://thesocialchangeagency.org/blog/how-to-create-and-manage-a-community-of-practice-or-peer-network/'
  },
  {
    title: 'The Manager\'s Path',
    description: 'Camille Fournier\'s book on building and scaling effective management practices.',
    url: 'https://www.oreilly.com/library/view/the-managers-path/9781491973882/'
  }
];

const ManagerCommunityUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Additional Resources" 
            items={additional} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default ManagerCommunityUsefulResources; 